import CalculateAge from "../helpers/CalculateAge";
import {
  validateEmail,
  validateFileType,
  validateFileSize,
  validateFileNameSpecialChar,
  validateLength,
  validateMaxLength,
  validatePassword,
  validateRequired,
  validatePostiveInteger,
  /* validateNoOrOneSpace, */
  validateAlphaNumericWithSymbols,
  validateEgyptianPhoneNumber,
  validateOnlyArabicOrEnglishNoSpaces,
  validateOnlyArabicOrEnglishOneSpaceBetweenWords,
  validateAllowedCharForEmail,
  validateMinLength,
} from "../helpers/Validation";

const ValidateRegister = (setError, user) => {
  let valid = true;
  //valid user First Name
  if (!validateRequired(user.first_name)) {
    valid = false;
    setError("first_name", "يجب إدخال الإسم الأول");
  } else if (!validateMaxLength(user.first_name, 24)) {
    valid = false;
    setError("first_name", "الحد الأقصي 24 حرف");
  } else if (
    !validateOnlyArabicOrEnglishOneSpaceBetweenWords(user.first_name)
  ) {
    valid = false;
    setError(
      "first_name",
      "يجب أن يحتوي باقي الإسم على حروف فقط (عربي أو إنجليزي) و مسموح بمسافة واحدة فقط بين الكلمات",
    );
  } /* else if (
    !validateIsArabicString(user.first_name) &&
    user.nationality_code === "EG"
  ) {
    valid = false;
    setError("first_name", "يجب ان يكون صيغة الأسم بالعربي.");
  } */ else {
    setError("first_name");
  }

  //valid user Family Name
  if (!validateRequired(user.last_name)) {
    valid = false;
    setError("last_name", "يجب إدخال باقي الإسم");
  } else {
    if (!validateMaxLength(user.last_name, 64)) {
      valid = false;
      setError("last_name", "الحد الأقصي 64 حرف");
    } else if (
      !validateOnlyArabicOrEnglishOneSpaceBetweenWords(user.last_name)
    ) {
      valid = false;
      setError(
        "last_name",
        "يجب أن يحتوي باقي الإسم على حروف فقط (عربي أو إنجليزي) و مسموح بمسافة واحدة فقط بين الكلمات",
      );
    } /* else if (
      !validateIsArabicString(user.last_name) &&
      user.nationality_code === "EG"
    ) {
      valid = false;
      setError("last_name", "يجب ان يكون صيغة الأسم بالعربي.");
    } */ else {
      setError("last_name");
    }
  }
  //validate user nationlity
  if (!validateRequired(user.nationality_code)) {
    valid = false;
    setError("nationality_code", "يجب اختيار الجنسية");
  } else {
    setError("nationality_code");
  }
  if (user.nationality_code === "EG") {
    //validate national id
    if (!validateRequired(user.national_id)) {
      valid = false;
      setError("national_id", "يجب إدخال الرقم القومي");
    } else if (
      !validateLength(user.national_id, 14) ||
      !validatePostiveInteger(user.national_id)
    ) {
      valid = false;
      setError("national_id", "يجب إدخال الرقم القومي المكون من 14 رقمًا فقط");
    } else {
      setError("national_id");
    }

    if (!validateRequired(user.national_id_file)) {
      valid = false;
      setError("national_id_file", "يجب رفع الصورة");
    } else if (!validateFileType(user.national_id_file)) {
      valid = false;
      setError("national_id_file", "يجب ان يكون PDF, JFIF, JPEG, JPG, أو PNG");
    } else if (!validateFileSize(user.national_id_file)) {
      valid = false;
      setError("national_id_file", "لا يجب أن يتجاوز 5 ميجابايت");
    } else if (!validateFileNameSpecialChar(user.national_id_file)) {
      valid = false;
      setError(
        "national_id_file",
        "اسم الملف لا يجب أن يحتوي على ! @ # $ % ^ & * + = [ ] { } ; \\ ' : \" | , < > / ? ` وأكثر من نقطة ”.“",
      );
    } else {
      setError("national_id_file");
    }
    //valid user factory number
    /* if (!validateRequired(user.factory_num)) {
      valid = false;
      setError("factory_num", "رجاء إدخال البيانات");
    } else {
      if (!validateMaxLength(user.factory_num, 10)) {
        valid = false;
        setError("factory_num", "الحد الأقصي 10 حروف");
      } else if (validateSpicalCharacters(user.factory_num)) {
        valid = false;
        setError("factory_num", "لا يجب ان يحتوي علي رموز");
      } else {
        setError("factory_num");
      }
    } */
  }

  if (user.nationality_code !== "EG" && user.nationality_code !== "") {
    //validate passport number
    if (!validateRequired(user.passport_num)) {
      valid = false;
      setError("passport_num", "يجب إدخال رقم جواز السفر");
    } else {
      if (!validateMaxLength(user.passport_num, 24)) {
        valid = false;
        setError("passport_num", "الحد الأقصي 24 حرف");
      } else if (!validateAlphaNumericWithSymbols(user.passport_num)) {
        valid = false;
        setError(
          "passport_num",
          "رقم جواز السفر يجب ان يحتوي فقط علي حروف انجليزية و أرقام و ('-' و '/'(",
        );
      } else if (validateMinLength(user.passport_num, 6)) {
        valid = false;
        setError("passport_num", "أقل عدد حروف 6 و أقصى عدد 24");
      } else {
        setError("passport_num");
      }
    }

    if (!validateRequired(user.passport_num_file)) {
      valid = false;
      setError("passport_num_file", "يجب رفع الصورة");
    } else if (!validateFileType(user.passport_num_file)) {
      valid = false;
      setError("passport_num_file", "يجب ان يكون PDF, JFIF, JPEG, JPG, أو PNG");
    } else if (!validateFileSize(user.passport_num_file)) {
      valid = false;
      setError("passport_num_file", "لا يجب أن يتجاوز 5 ميجابايت");
    } else if (!validateFileNameSpecialChar(user.passport_num_file)) {
      valid = false;
      setError(
        "passport_num_file",
        "اسم الملف لا يجب أن يحتوي على ! @ # $ % ^ & * + = [ ] { } ; \\ ' : \" | , < > / ? ` وأكثر من نقطة ”.“",
      );
    } else {
      setError("passport_num_file");
    }
  }
  //validate phone number
  if (!validateRequired(user.mobile)) {
    valid = false;
    setError("mobile", "يجب ادخال رقم الهاتف المحمول");
  } else if (validateMinLength(user.mobile, 6)) {
    valid = false;
    setError(
      "mobile",
      "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
    );
  } else if (!validateMinLength(user.mobile, 15)) {
    valid = false;
    setError(
      "mobile",
      "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
    );
  } else {
    setError("mobile");
  }

  //valid user birth_date
  if (!validateRequired(user.birth_date)) {
    valid = false;
    setError("birth_date", "يجب ادخال تاريخ الميلاد");
  } else {
    if (CalculateAge(user.birth_date) < 18) {
      valid = false;
      setError("birth_date", "يجب أن يكون عمر المستخدم أكبر من 18 عام");
    } else {
      setError("birth_date");
    }
  }

  if (!validateRequired(user.birth_date)) {
    valid = false;
    setError("birth_date", "يجب ادخال تاريخ الميلاد");
  } else {
    if (CalculateAge(user.birth_date) < 18) {
      valid = false;
      setError("birth_date", "يجب أن يكون عمر المستخدم أكبر من 18 عام");
    } else if (user.nationality_code === "EG" && user.national_id !== "") {
      const d = new Date(user.birth_date);
      const year = d.getFullYear();
      const century = centuryDepondYear(year);
      const dob = getDob(user.national_id.substring(0, 7));
      if (
        century !== parseInt(user.national_id[0]) ||
        dob !== user.birth_date
      ) {
        valid = false;
        setError("birth_date", "تاريخ الميلاد لا يتوافق مع الرقم القومي");
      } else {
        setError("birth_date");
      }
    } else {
      setError("birth_date");
    }
  }
  //validate birth_place
  if (!validateRequired(user.birth_place)) {
    valid = false;
    setError("birth_place", "يجب اختيار محل الميلاد");
  } else if (user.nationality_code === "EG" && user.national_id !== "") {
    if (user.national_id.substring(7, 9) !== user.birth_place) {
      valid = false;
      setError("birth_place", "محل الميلاد لا يتوافق مع الرقم القومي");
    } else {
      setError("birth_place");
    }
  } else {
    setError("birth_place");
  }

  //validate other_birth_place
  if (user.birth_place === "88") {
    if (!validateRequired(user.other_birth_place)) {
      valid = false;
      setError("birth_place", "يجب إدخال محل الميلاد الآخر");
    } else if (!validateMaxLength(user.other_birth_place, 100)) {
      valid = false;
      setError("other_birth_place", "الحد الأقصي 100 حرف");
    } else if (
      !validateOnlyArabicOrEnglishOneSpaceBetweenWords(user.other_birth_place)
    ) {
      valid = false;
      setError(
        "other_birth_place",
        "يجب أن يحتوي باقي الإسم على حروف فقط (عربي أو إنجليزي) و مسموح بمسافة واحدة فقط بين الكلمات",
      );
    } else {
      setError("other_birth_place");
    }
  }
  //validate gender
  if (!validateRequired(user.gender)) {
    valid = false;
    setError("gender", "يجب اختيار النوع");
  } else if (user.nationality_code === "EG" && user.national_id !== "") {
    if (
      (parseInt(user.national_id[12]) % 2 === 0 &&
        parseInt(user.gender) === 1) ||
      (parseInt(user.national_id[12]) % 2 !== 0 && parseInt(user.gender) === 2)
    ) {
      valid = false;
      setError("gender", " النوع لا يتوافق مع الرقم القومي");
    } else {
      setError("gender");
    }
  } else {
    setError("gender");
  }

  if (user?.country_code !== "eg") {
    if (!validateRequired(user.email)) {
      valid = false;
      setError("email", "يجب إدخال البريد الإلكتروني");
    } else {
      setError("email");
    }
  } else {
    setError("email");
  }
  //validate email
  if (user.email !== "" || user.email == null) {
    if (!validateEmail(user.email)) {
      valid = false;
      setError("email", "بريد إلكتروني غير صالح");
    } else {
      if (!validateMaxLength(user.email, 100)) {
        valid = false;
        setError("email", "الحد الأقصي 100 حرف");
      } else {
        setError("email");
      }
    }
  }

  //validate password
  if (!validateRequired(user.password)) {
    valid = false;
    setError("password", "يجب إدخال كلمة المرور");
  } else if (
    validateMinLength(user.password, 8) ||
    !validatePassword(user.password)
  ) {
    valid = false;
    setError(
      "password",
      "كلمه السر يجب أن تحتوي ع حرف كبير وحرف صغير و رقم ولا يقل عن 8 حروف ولا يزيد عن 10 حروف",
    );
  } else if (!validateMaxLength(user.password, 10)) {
    valid = false;
    setError(
      "password",
      "كلمه السر يجب أن تحتوي ع حرف كبير وحرف صغير و رقم ولا يقل عن 8 حروف ولا يزيد عن 10 حروف",
    );
  } else {
    setError("password");
  }

  //validate password_confirm
  if (!validateRequired(user.password_confirmation)) {
    valid = false;
    setError("password_confirmation", "يجب تأكيد كلمة المرور");
  } else if (user.password !== user.password_confirmation) {
    valid = false;
    setError("password_confirmation", "يجب أن تطابق مع كلمة المرور");
  } else {
    setError("password_confirmation");
  }

  return valid;
};
function centuryDepondYear(year) {
  const startYear = 1900;
  let century = 1;
  for (let index = startYear; index < year; index += 99) {
    century++;
  }
  return century;
}

function getDob(idNumber) {
  // idNumber must now be the first 7 digits: CYYMMDD
  var century = idNumber.substring(0, 1); // "2" or "3"
  var Year = idNumber.substring(1, 3);
  var Month = idNumber.substring(3, 5);
  var Day = idNumber.substring(5, 7);

  var fullYearPrefix = century === "2" ? "19" : "20";
  var dob = fullYearPrefix + Year + "-" + Month + "-" + Day;

  return dob;
}

const validateRegisterFields = (setError, user, fieldName, value) => {
  let valid = true;
  switch (fieldName) {
    case "first_name":
      //valid user First Name
      if (!validateRequired(value)) {
        valid = false;
        setError("first_name", "يجب إدخال الإسم الأول");
      } else {
        if (!validateMaxLength(value, 24)) {
          valid = false;
          setError("first_name", "الحد الأقصي 24 حرف");
        } else if (!validateOnlyArabicOrEnglishOneSpaceBetweenWords(value)) {
          valid = false;
          setError(
            "first_name",
            "يجب أن يحتوي الإسم الأول على حروف فقط (عربي أو إنجليزي) و مسموح بمسافة واحدة فقط بين الكلمات",
          );
        } /* else if (
          !validateIsArabicString(value) &&
          user.nationality_code === "EG"
        ) {
          valid = false;
          setError("first_name", "يجب ان يكون صيغة الأسم بالعربي.");
        } */ else {
          setError("first_name");
        }
      }
      break;
    case "last_name":
      if (!validateRequired(value)) {
        valid = false;
        setError("last_name", "يجب إدخال باقي الإسم");
      } else {
        if (!validateMaxLength(value, 64)) {
          valid = false;
          setError("last_name", "الحد الأقصي 64 حرف");
        } else if (!validateOnlyArabicOrEnglishOneSpaceBetweenWords(value)) {
          valid = false;
          setError(
            "last_name",
            "يجب أن يحتوي باقي الإسم على حروف فقط (عربي أو إنجليزي) و مسموح بمسافة واحدة فقط بين الكلمات",
          );
        } /* else if (
          !validateIsArabicString(value) &&
          user.nationality_code === "EG"
        ) {
          valid = false;
          setError("last_name", "يجب ان يكون صيغة الأسم بالعربي.");
        } */ else {
          setError("last_name");
        }
      }
      break;
    case "nationality_code":
      if (!validateRequired(value)) {
        valid = false;
        setError("nationality_code", "يجب اختيار الجنسية");
      } else {
        setError("nationality_code");
      }
      break;
    case "national_id":
      if (!validateRequired(value)) {
        valid = false;
        setError("national_id", "يجب إدخال الرقم القومي");
      } else if (!validateLength(value, 14) || !validatePostiveInteger(value)) {
        valid = false;
        setError(
          "national_id",
          "يجب إدخال الرقم القومي المكون من 14 رقمًا فقط",
        );
      } else {
        setError("national_id");
      }
      break;
    case "national_id_file":
      if (!validateRequired(value)) {
        valid = false;
        setError("national_id_file", "يجب رفع الصورة");
      } else if (!validateFileType(value)) {
        valid = false;
        setError(
          "national_id_file",
          "يجب ان يكون PDF, JFIF, JPEG, JPG, أو PNG",
        );
      } else if (!validateFileSize(value)) {
        valid = false;
        setError("national_id_file", "لا يجب أن يتجاوز 5 ميجابايت");
      } else if (!validateFileNameSpecialChar(value)) {
        valid = false;
        setError(
          "national_id_file",
          "اسم الملف لا يجب أن يحتوي على ! @ # $ % ^ & * + = [ ] { } ; \\ ' : \" | , < > / ? ` وأكثر من نقطة ”.“",
        );
      } else {
        setError("national_id_file");
      }
      break;
    case "passport_num":
      if (!validateRequired(value)) {
        valid = false;
        setError("passport_num", "يجب إدخال رقم جواز السفر");
      } else {
        if (!validateMaxLength(value, 24)) {
          valid = false;
          setError("passport_num", "الحد الأقصي 24 حرف");
        } else if (!validateAlphaNumericWithSymbols(value)) {
          valid = false;
          setError(
            "passport_num",
            "رقم جواز السفر يجب ان يحتوي فقط علي حروف انجليزية و أرقام و ('-' و '/')",
          );
        } else {
          setError("passport_num");
        }
      }
      break;
    case "passport_num_file":
      if (!validateRequired(value)) {
        valid = false;
        setError("passport_num_file", "يجب رفع الصورة");
      } else if (!validateFileType(value)) {
        valid = false;
        setError(
          "passport_num_file",
          "يجب ان يكون PDF, JFIF, JPEG, JPG, أو PNG",
        );
      } else if (!validateFileSize(value)) {
        valid = false;
        setError("passport_num_file", "لا يجب أن يتجاوز 5 ميجابايت");
      } else if (!validateFileNameSpecialChar(value)) {
        valid = false;
        setError(
          "passport_num_file",
          "اسم الملف لا يجب أن يحتوي على ! @ # $ % ^ & * + = [ ] { } ; \\ ' : \" | , < > / ? ` وأكثر من نقطة ”.“",
        );
      } else {
        setError("passport_num_file");
      }
      break;
    case "mobile":
      if (!validateRequired(value)) {
        valid = false;
        setError("mobile", "يجب ادخال رقم الهاتف المحمول");
      } else {
        setError("mobile");
      }
      break;
    case "birth_date":
      if (!validateRequired(value)) {
        valid = false;
        setError("birth_date", "يجب ادخال تاريخ الميلاد");
      } else {
        if (CalculateAge(value) < 18) {
          valid = false;
          setError("birth_date", "يجب أن يكون عمر المستخدم أكبر من 18 عام");
        } else if (user.nationality_code === "EG" && user.national_id !== "") {
          const d = new Date(value);
          const year = d.getFullYear();
          const century = centuryDepondYear(year);
          const dob = getDob(user.national_id.substring(0, 7));
          if (century !== parseInt(user.national_id[0]) || dob !== value) {
            setError("birth_date", "تاريخ الميلاد لا يتوافق مع الرقم القومي");
          } else {
            setError("birth_date");
          }
        } else {
          setError("birth_date");
        }
      }
      break;
    case "birth_place":
      if (!validateRequired(value)) {
        valid = false;
        setError("birth_place", "يجب اختيار محل الميلاد");
      } else if (user.nationality_code === "EG" && user.national_id !== "") {
        if (user.national_id.substring(7, 9) !== value) {
          setError("birth_place", "محل الميلاد لا يتوافق مع الرقم القومي");
        } else {
          setError("birth_place");
        }
      } else {
        setError("birth_place");
      }
      break;
    case "other_birth_place":
      if (!validateRequired(value)) {
        valid = false;
        setError("other_birth_place", "يجب إدخال محل الميلاد الآخر");
      } else if (!validateMaxLength(value, 100)) {
        valid = false;
        setError("other_birth_place", "الحد الأقصي 100 حرف");
      } else if (!validateOnlyArabicOrEnglishOneSpaceBetweenWords(value)) {
        valid = false;
        setError(
          "other_birth_place",
          "يجب أن يحتوي باقي الإسم على حروف فقط (عربي أو إنجليزي) و مسموح بمسافة واحدة فقط بين الكلمات",
        );
      } else {
        setError("other_birth_place");
      }
      break;
    case "gender":
      if (!validateRequired(value)) {
        valid = false;
        setError("gender", "يجب اختيار النوع");
      } else if (user.nationality_code === "EG" && user.national_id !== "") {
        if (
          (parseInt(user.national_id[12]) % 2 === 0 && parseInt(value) === 1) ||
          (parseInt(user.national_id[12]) % 2 !== 0 && parseInt(value) === 2)
        ) {
          setError("gender", " النوع لا يتوافق مع الرقم القومي");
        } else {
          setError("gender");
        }
      } else {
        setError("gender");
      }
      break;
    case "email":
      if (!validateMaxLength(value, 100)) {
        valid = false;
        setError("email", "الحد الأقصي 100 حرف");
      } else if (value !== "" && !validateAllowedCharForEmail(value)) {
        valid = false;
        setError(
          "email",
          "لا يجب أن يحتوي البريد الإكتروني على حروف إنجليزي فقط و هذة الرموز(-,.,_)",
        );
      } else {
        setError("email");
      }
      break;
    case "password":
      if (!validateRequired(value)) {
        valid = false;
        setError("password", "يجب إدخال كلمة المرور");
      } else {
        setError("password");
      }
      break;
    case "password_confirmation":
      if (!validateRequired(value)) {
        valid = false;
        setError("password_confirmation", "يجب تأكيد كلمة المرور");
      } else {
        setError("password_confirmation");
      }
      break;

    /* case "second_name":
      //valid user Second Name
      if (!validateRequired(value)) {
        valid = false;
        setError("second_name", "رجاء إدخال البيانات");
      } else {
        if (!validateMaxLength(value, 255)) {
          valid = false;
          setError("second_name", "الحد الأقصي 255 حروف");
        } else if (validateSpicalCharacters(value)) {
          valid = false;
          setError("second_name", "لا يجب ان يحتوي علي رموز");
        } else if (validateDigitCharacters(value)) {
          valid = false;
          setError("second_name", "لا يجب ان يحتوي علي أرقام");
        } else if (validateNoOrOneSpace(value)) {
          valid = false;
          setError("second_name", "مسموح بمسافة واحدة فقط");
        } else if (
          !validateIsArabicString(value) &&
          user.nationality_code === "EG"
        ) {
          valid = false;
          setError("second_name", "يجب ان يكون صيغة الأسم بالعربي.");
        } else {
          setError("second_name");
        }
      }
      break; */
    /* case "third_name":
      if (!validateRequired(value)) {
        valid = false;
        setError("third_name", "رجاء إدخال البيانات");
      } else {
        if (!validateMaxLength(value, 255)) {
          valid = false;
          setError("third_name", "الحد الأقصي 255 حروف");
        } else if (validateSpicalCharacters(value)) {
          valid = false;
          setError("third_name", "لا يجب ان يحتوي علي رموز");
        } else if (validateDigitCharacters(value)) {
          valid = false;
          setError("third_name", "لا يجب ان يحتوي علي أرقام");
        } else if (validateNoOrOneSpace(value)) {
          valid = false;
          setError("third_name", "مسموح بمسافة واحدة فقط");
        } else if (
          !validateIsArabicString(value) &&
          user.nationality_code === "EG"
        ) {
          valid = false;
          setError("third_name", "يجب ان يكون صيغة الأسم بالعربي.");
        } else {
          setError("third_name");
        }
      }
      break; */

    /* case "factory_num":
      if (!validateRequired(value)) {
        valid = false;
        setError("factory_num", "رجاء إدخال البيانات");
      } else {
        if (!validateMaxLength(value, 10)) {
          valid = false;
          setError("factory_num", "الحد الأقصي 10 حروف");
        } else if (validateSpicalCharacters(value)) {
          valid = false;
          setError("factory_num", "لا يجب ان يحتوي علي رموز");
        } else {
          setError("factory_num");
        }
      }
      break; */
    /* case "street_other":
      if (parseInt(user.street_id) === -1) {
        if (!validateRequired(value)) {
          valid = false;
          setError("street_other", "رجاء إدخال البيانات");
        } else {
          if (!validateMaxLength(value, 255)) {
            valid = false;
            setError("street_other", "الحد الأقصي 255 حروف");
          } else if (validateSpicalCharacters(value)) {
            valid = false;
            setError("street_other", "لا يجب ان يحتوي علي رموز");
          } else {
            setError("street_other");
          }
        }
      }
      break; */
    /* case "governorate_id":
      //validate governate
      if (!validateRequired(value)) {
        valid = false;
        setError("governorate_id", "رجاء إدخال البيانات");
      } else {
        setError("governorate_id");
      }
      break; */
    /* case "district_id":
      //validate city
      if (!validateRequired(value)) {
        valid = false;
        setError("district_id", "رجاء إدخال البيانات");
      } else {
        setError("district_id");
      }
      break; */
    /* case "village_id":
      //validate area
      if (!validateRequired(value)) {
        valid = false;
        setError("village_id", "رجاء إدخال البيانات");
      } else {
        setError("village_id");
      }
      break; */
    /*  case "street_id":
      //validate street
      if (!validateRequired(value)) {
        valid = false;
        setError("street_id", "رجاء إدخال البيانات");
      } else {
        setError("street_id");
      }
      break; */
    /* case "real_estate_num":
      if (!validateRequired(value)) {
        valid = false;
        setError("real_estate_num", "رجاء إدخال البيانات");
      } else {
        if (!validateMaxLength(value, 100)) {
          valid = false;
          setError("real_estate_num", "الحد الأقصي 100 حرف");
        } else {
          setError("real_estate_num");
        }
      }
      break; */
    default:
      break;
  }
  return valid;
};
export { validateRegisterFields, ValidateRegister };
